import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0312d7e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "function-video"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    title: _ctx.title + ' · 功能演示',
    footer: null,
    width: 860,
    destroyOnClose: true,
    onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      (_ctx.visible && _ctx.safeUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(), _createElementBlock("video", {
              key: _ctx.safeUrl,
              src: _ctx.safeUrl,
              controls: "",
              playsinline: "",
              preload: "metadata",
              onError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.failed = true)),
              onLoadeddata: _cache[1] || (_cache[1] = ($event: any) => (_ctx.failed = false))
            }, null, 40, _hoisted_2)),
            (_ctx.failed)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, "视频暂时无法播放，请检查网络或联系管理员核对视频地址。"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}